import {Module, Mutation, VuexModule} from 'vuex-module-decorators';

import {Status} from '@/model/Messaging';

@Module({name: 'AppStore', namespaced: true})
export class AppStore extends VuexModule {

  private apiAvailable: boolean = true;
  private messagingStatus: Status = Status.Disconnected;
  private loading: boolean = false;

  @Mutation
  public setApiAvailable(available: boolean) {
    this.apiAvailable = available;
  }

  get ApiAvailable(): boolean {
    return this.apiAvailable;
  }


  @Mutation
  public setMessagingStatus(status: Status) {
    this.messagingStatus = status;
  }

  get MessagingStatus(): Status {
    return this.messagingStatus;
  }


  @Mutation
  public setLoading(loading: boolean) {
    this.loading = loading;
  }

  get Loading(): boolean {
    return this.loading;
  }
}
